export function isDeletedRecord(item) {
    return Boolean(item?.deleted_at)
}

export function isTaskRecord(item) {
    const flag = item?.is_task
    return flag === 1 || flag === true || flag === '1'
}

export function isDeletedTask(item) {
    return isDeletedRecord(item) && isTaskRecord(item)
}

export function isDeletedNote(item) {
    return isDeletedRecord(item) && !isTaskRecord(item)
}

export function omitDeletedTasks(list) {
    if (!Array.isArray(list)) {
        return []
    }
    return list.filter((item) => !isDeletedTask(item))
}

export function omitDeletedRecords(list) {
    if (!Array.isArray(list)) {
        return []
    }
    return list.filter((item) => !isDeletedRecord(item))
}

/** Keep soft-deleted notes and tasks on the case Notes/Tasks tab. Hide them when that tab is not available. */
export function caseNotesForViewer(list, canSeeNotesTab) {
    if (!Array.isArray(list)) {
        return list
    }
    return canSeeNotesTab ? list : omitDeletedRecords(list)
}

export function deletedTaskIdsInPatch(notes) {
    if (!Array.isArray(notes)) {
        return []
    }
    return notes.filter(isDeletedTask).map((item) => item.id).filter((id) => id != null)
}

export function deletedRecordIds(items) {
    if (!Array.isArray(items)) {
        return []
    }
    return items.filter(isDeletedRecord).map((item) => item.id).filter((id) => id != null)
}

export function removeDeletedIds(list, ids) {
    if (!Array.isArray(list) || !ids || ids.size === 0) {
        return list
    }
    return list.filter((item) => !ids.has(String(item?.id)))
}

export function withoutDeletedQueueFields(incoming) {
    if (!incoming || typeof incoming !== 'object') {
        return incoming
    }
    const next = { ...incoming }
    if (Object.prototype.hasOwnProperty.call(incoming, 'notes')) {
        next.notes = omitDeletedRecords(incoming.notes)
    }
    if (Object.prototype.hasOwnProperty.call(incoming, 'task_notes')) {
        next.task_notes = omitDeletedRecords(incoming.task_notes)
    }
    if (Object.prototype.hasOwnProperty.call(incoming, 'tasks')) {
        next.tasks = omitDeletedRecords(incoming.tasks)
    }
    return next
}

export function resolveNoteCaseId(item, caseData, activeCase) {
    return item?.case_id
        ?? item?.case?.id
        ?? caseData?.case?.id
        ?? caseData?.case_id
        ?? activeCase?.case?.id
        ?? null
}
